/** Convert Supabase email callbacks before HashRouter or the auth client consumes the fragment. */
export function passwordCallbackRedirect(href: string): string | null {
  const url = new URL(href);
  const hash = url.hash.slice(1);
  const routed = hash.startsWith("/");
  const separator = hash.indexOf("?");
  const hashParams = new URLSearchParams(
    routed ? (separator < 0 ? "" : hash.slice(separator + 1)) : hash,
  );
  const read = (name: string) =>
    hashParams.get(name) ?? url.searchParams.get(name);
  const type = read("type");
  const isPassword = type === "recovery" || type === "invite";
  const expired = read("error_code") === "otp_expired";
  if (!isPassword && !expired) return null;
  const params = new URLSearchParams();
  const access = read("access_token"),
    refresh = read("refresh_token");
  const valid = (value: string | null): value is string =>
    !!value && value !== "null" && value !== "undefined";
  if (isPassword && valid(access) && valid(refresh) && !read("error")) {
    params.set("access_token", access);
    params.set("refresh_token", refresh);
    params.set("type", type!);
  } else {
    params.set("error", expired ? "otp_expired" : "invalid_link");
  }
  // Never put credentials in the HTTP query string or accept a caller-supplied destination.
  url.search = "";
  url.pathname = url.pathname.replace(
    /\/(?:auth-callback\.html|set-password)\/?$/,
    "/",
  );
  url.hash = `/set-password?${params}`;
  return url.href === href ? null : url.href;
}
